export const mallGoodGroup = [
  {
    label: '等级权限',
    value: 1
  },
  {
    label: '限量闪兑',
    value: 2
  },
  {
    label: '积分豪兑',
    value: 3
  }
];
export const redirectData = [
  {
    label: '直播提醒',
    value: 'liveForeshow'
  },
  {
    label: '精彩课程',
    value: 'Chair'
  },
  {
    label: '热点资讯',
    value: 'INFORMATION'
  },
  {
    label: '外链',
    value: 'Link'
  }
];
export const levelData = [
  {
    label: '一级甲等',
    value: '一级甲等'
  },
  {
    label: '二级甲等',
    value: '二级甲等'
  },
  {
    label: '三级甲等',
    value: '三级甲等'
  },
  {
    label: '三级特等',
    value: '三级特等'
  },
  {
    label: '一级乙等',
    value: '一级乙等'
  },
  {
    label: '二级乙等',
    value: '二级乙等'
  },
  {
    label: '三级乙等',
    value: '三级乙等'
  },
  {
    label: '一级丙等',
    value: '一级丙等'
  },
  {
    label: '二级丙等',
    value: '二级丙等'
  },
  {
    label: '三级丙等',
    value: '三级丙等'
  }
];
export const natureData = [
  {
    label: '民营',
    value: 1
  },
  {
    label: '公立',
    value: 2
  }
];
// 商品类别 1:一类学分 2:二类学分 3:实物类 4:虚拟类
export const mallGoodType = [
  {
    label: '一类学分',
    value: 1
  },
  {
    label: '二类学分',
    value: 2
  },
  {
    label: '实物类',
    value: 3
  },
  {
    label: '虚拟类',
    value: 4
  }
];
// 题库中 废弃 耻辱
export const courseType = [
  {
    label: '直播',
    value: 1
  },
  {
    label: '录播',
    value: 2
  }
];
// 课程中
export const courseType2 = [
  {
    label: '直播',
    value: 1
  },
  {
    label: '录播',
    value: 0
  }
];
// 是否
export const whetherOrNot = [
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
];
export const skypeType = [
  {
    label: '专题',
    value: 1
  },
  {
    label: '访问',
    value: 2
  },
  {
    label: '报道',
    value: 3
  }
];
export const skypeType2 = [
  {
    label: '访问',
    value: 1
  },
  {
    label: '报道',
    value: 2
  }
];
export const match = [
  {
    label: '完全匹配',
    value: 1
  },
  {
    label: '包含匹配',
    value: 0
  }
];
export const payStatus = [
  {
    label: '未支付',
    value: 0
  },
  {
    label: '已支付',
    value: 1
  }
];
export const courseType3 = [
  {
    label: '精品课',
    value: 2
  },
  {
    label: '培训班',
    value: 3
  }
];
export const payChannel = [
  {
    label: '未支付',
    value: 0
  },
  {
    label: '已支付',
    value: 1
  }
];
export const payWay = [
  {
    label: '线上',
    value: 1
  },
  {
    label: '线下',
    value: 2
  }
];
export const keywordData = [
  {
    label: '关键字',
    value: 'custom'
  },
  {
    label: '关注',
    value: 'subscribeEvent'
  }
];
export const sendType = [
  {
    label: '图文连接',
    value: 'news'
  },
  {
    label: '文本',
    value: 'text'
  }
];
export const sendStatus = [
  {
    label: '草稿',
    value: 0
  },
  {
    label: '已发布',
    value: 1
  }
];
export const positionData = [
  {
    label: '直播预告',
    value: 'appMainBanner'
  },
  {
    label: '讨论首页',
    value: 'appDiscussion'
  },
  {
    label: '频道首页',
    value: 'appChannel'
  },
  {
    label: 'banner活动',
    value: 'appActivityBanner'
  }
];
export const jumpData1 = [
  {
    label: '直播预告',
    value: 'LiveForeshow'
  },
  {
    label: '视频',
    value: 'Chair'
  },
  {
    label: '外链',
    value: 'Link'
  },
  {
    label: '阅读帖子',
    value: 'BBS'
  },
  {
    label: '阅读资讯',
    value: 'INFORMATION'
  },
  {
    label: '阅读病例',
    value: 'CASE'
  },
  {
    label: '频道',
    value: 'MyChannels'
  },
  {
    label: '频道外链',
    value: 'channelLink'
  }
];
export const jumpData2 = [
  {
    label: '直播预告',
    value: 'WxLiveForeshow'
  },
  {
    label: '答题新用户',
    value: 'DatiShareBanner'
  }
];
export const pointType = [
  {
    label: '首页',
    value: 1
  },
  {
    label: '直播',
    value: 2
  },
  {
    label: '录播',
    value: 3
  },
  {
    label: '链接',
    value: 5
  },
  {
    label: '普通学院',
    value: 6
  },
  {
    label: '学院外链',
    value: 7
  }
];
export const terminal = [
  {
    label: 'WX',
    value: 1
  },
  {
    label: 'PC',
    value: 2
  },
  {
    label: 'APP',
    value: 3
  }
];
export const jpkstudentListStatus = [
  {
    label: '未支付',
    value: 0
  },
  {
    label: '已支付',
    value: 1
  }
];
export const jpkstudentListWay = [
  {
    label: '线上支付',
    value: 1
  },
  {
    label: '线下支付',
    value: 2
  }
];
export const controlPanelType = [
  {
    label: '直播详情页',
    value: 'liveDetail'
  },
  {
    label: '录播详情页',
    value: 'videoDetail'
  },
  {
    label: '资讯详情页',
    value: 'informationDetail'
  },
  {
    label: '帖子详情页',
    value: 'postDetail'
  },
  {
    label: '病例详情页',
    value: 'caseDetail'
  },
  {
    label: '每日任务',
    value: 'dayTask'
  },
  {
    label: '积分商城',
    value: 'IntegralMall'
  },
  {
    label: '专区列表',
    value: 'channelList'
  },
  {
    label: '原生专区详情',
    value: 'nativeChannelDetail'
  },
  {
    label: '商业外链专区详情',
    value: 'extLinkChannelDetail'
  },
  {
    label: '答题挑战',
    value: 'challengeAnswer'
  },
  {
    label: '培训列表',
    value: 'jppxList'
  },
  {
    label: '外链',
    value: 'extLink'
  },
  {
    label: '超级面对面列表',
    value: 'cjmdmList'
  },
  {
    label: '超级面对面详情',
    value: 'cjmdmDetail'
  },
  {
    label: '资讯列表',
    value: 'informationList'
  },
  {
    label: '我的收藏',
    value: 'myCollection'
  },
  {
    label: '病例列表',
    value: 'caseList'
  },
  {
    label: '工作站',
    value: 'workstation'
  },
  {
    label: '意见反馈',
    value: 'feedback'
  },
  {
    label: '邀请好友',
    value: 'InvitingFriends'
  },
  {
    label: '帖子详情页',
    value: 'questionDetail'
  },
  {
    label: '培训班详情页',
    value: 'trainingClassDetail'
  },
  {
    label: '精品课详情',
    value: 'jpkDetail'
  },
  {
    label: '听课记录',
    value: 'lectureNotes'
  }
];
export const commentType = [
  {
    label: '病例',
    value: 2
  },
  {
    label: '资讯',
    value: 3
  },
  {
    label: '直播',
    value: 5
  },
  {
    label: '录播',
    value: 6
  },
  {
    label: '点赞',
    value: 7
  },
  {
    label: '用户帖子',
    value: 8
  }
];
export const businessCommentReviewed = [
  {
    label: '未通过',
    value: 0
  },
  {
    label: '已通过',
    value: 1
  }
];
export const businessCommentDelete = [
  {
    label: '未删除',
    value: 0
  },
  {
    label: '已删除',
    value: 1
  }
];
export const hospitalAuditStatus = [
  {
    label: '未审核',
    value: 0
  },
  {
    label: '提交审核',
    value: 1
  },
  {
    label: '审核通过',
    value: 2
  },
  {
    label: '审核未通过',
    value: 3
  }
];
export const userIdent = [
  {
    label: '医生',
    value: 1
  },
  {
    label: '护士',
    value: 2
  },
  {
    label: '药剂师',
    value: 3
  },
  {
    label: '医学生',
    value: 4
  },
  {
    label: '行政人员',
    value: 5
  }
];
export const userAuthStatus = [
  {
    label: '认证中',
    value: 1
  },
  {
    label: '认证通过',
    value: 2
  }
];
export const handleData = [
  {
    label: '未处理',
    value: 0
  },
  {
    label: '已处理',
    value: 1
  }
];
export const jppxCourseStatus = [
  {
    label: '未上架',
    value: 0
  },
  {
    label: '上架',
    value: 1
  },
  {
    label: '下架',
    value: 2
  },
  {
    label: '未开始',
    value: 3
  },
  {
    label: '进行中',
    value: 4
  },
  {
    label: '结束',
    value: 5
  }
];
export const onlinePromotionContentType = [
  {
    label: '课程',
    value: 1
  },
  {
    label: '资讯',
    value: 2
  },
  {
    label: '病例',
    value: 3
  }
];
export const pushAnswerTempType = [
  {
    label: '推送',
    value: 1
  },
  {
    label: '资讯展示',
    value: 2
  }
];

export const recordStatus = [
  {
    label: '审核中',
    value: 1
  },
  {
    label: '审核通过',
    value: 2
  },
  {
    label: '审核未通过',
    value: 3
  }
];
export const businessType = [
  {
    label: '四级汇总',
    value: 1
  },
  {
    label: '三级代开',
    value: 3
  },
  {
    label: '三级灵工服务',
    value: 5
  },
  {
    label: '三级个体',
    value: 7
  },
  {
    label: '工具',
    value: 9
  }
];
// 结算管理
export const payFinishList = [
  {
    label: '未付钱',
    value: 0
  },
  {
    label: '付款中',
    value: 1
  },
  {
    label: '已付款',
    value: 2
  },
  {
    label: '付款失败',
    value: 3
  }
];
export const projectAllList = [
  {
    //所有项目类型及路径由此维护
    filePath: 'academy',
    name: '学术拜访'
  },
  {
    filePath: 'otc',
    name: 'OTC拜访'
  },
  {
    filePath: 'ksh',
    name: '科室会'
  },
  {
    filePath: 'hjh',
    name: '患教会'
  },
  {
    filePath: 'survey',
    name: '医学助手项目调研'
  },
  {
    filePath: 'spread',
    name: '线上推广'
  },
  {
    filePath: 'yshSurvey',
    name: '医生调查问卷'
  },
  {
    filePath: 'case',
    name: '病例收集'
  },
  {
    filePath: 'lvlHospital',
    name: '等级医院拜访'
  },
  {
    filePath: 'baseHospital',
    name: '基层医疗机构拜访'
  },
  {
    filePath: 'accessSuper',
    name: '特级三甲医院市场准入'
  },
  {
    filePath: 'accessThird',
    name: '三级医院市场准入'
  },
  {
    filePath: 'accessSecond',
    name: '二级医院市场准入'
  },
  {
    filePath: 'accessBase',
    name: '基层医疗机构市场准入'
  },
  {
    filePath: 'accessRetail',
    name: '零售药店市场准入'
  },
  {
    filePath: 'health',
    name: 'AI健康管理'
  },
  {
    filePath: 'digital',
    name: '数字拜访'
  },
  {
    filePath: 'zsCase',
    name: '助手病例'
  },
  {
    filePath: 'protocolService',
    name: '协定服务'
  },
  {
    filePath: 'editScene',
    name: '可配置场景'
  },
  {
    filePath: 'digitalQuestionnaire',
    name: '数字问卷'
  }
];
// 问卷类型  类型 1 单选 2 多选 3 单项投票 4 单项填空 5 多项填空 6 打分题 7 地址
export const questionType = {
  '-3': {
    label: '定位题',
    value: -3
  },
  '-2': {
    label: '时间题',
    value: -2,
    children: {
      1: {
        label: '时间段题',
        value: -2,
        secondType: 1
      },
      2: {
        label: '时刻题',
        value: -2,
        secondType: 2
      }
    }
  },
  '-1': {
    label: '目标题',
    value: -1
  },
  1: {
    label: '单选题',
    value: 1
  },
  2: {
    label: '多选题',
    value: 2
  },
  3: {
    label: '单选投票题',
    value: 3
  },
  4: {
    label: '单项填空题',
    value: 4
  },
  5: {
    label: '多项填空题',
    value: 5
  },
  6: {
    label: '打分题',
    value: 6
  },
  7: {
    label: '地址',
    value: 7
  },
  8: {
    label: '上传附件',
    value: 8
  },
  9: {
    label: '上传pdf',
    value: 9
  },
  10: {
    label: '上传word',
    value: 10
  },
  11: {
    label: '上传excel',
    value: 11
  },
  12: {
    label: '上传ppt',
    value: 12
  },
  13: {
    label: '上传图片',
    value: 13
  },
  14: {
    label: '时间题',
    value: 14
  },
  15: {
    label: '月度题',
    value: 15
  },
  16: {
    label: '定位题',
    value: 16
  },
  17: {
    label: '描述题',
    value: 17
  },
  18: {
    label: '描述题',
    value: 18
  },
  19: {
    label: '数字填空题',
    value: 19
  },
  20: {
    label: '签名题',
    value: 20
  },
  21: {
    label: '签到题', // 未使用
    value: 21
  },
  22: {
    label: '姓名填空题',
    value: 22
  }
};
let list = [
  '学术拜访',
  'OTC拜访',
  '科室会',
  '患教会',
  '医学助手项目调研',
  '线上推广',
  '医生调查问卷',
  '病例收集',
  '等级医院拜访',
  '基层医疗机构拜访',
  '特级三甲医院市场准入',
  '三级医院市场准入',
  '二级医院市场准入',
  '基层医疗机构市场准入',
  '零售药店市场准入',
  'AI健康管理'
];
